import { userConstants } from '../constants';
import { userService } from '../loginService';
// import { alertActions } from './';
import { history } from '../helpers';
import { errorActions } from './errorDisplay.actions';

export const userActions = {
    login,
    logout,
    getAll
};

function login(username, password) {
    return dispatch => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(errorActions.reset());
                    history.push('/');
                },
                error => {
                    dispatch(failure(error));
                    // dispatch(alertActions.error(error));
                    window.alert("密碼或帳號輸入錯誤");
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

// function logFB(FBtoken) {
//   return dispatch => {
//     dispatch(request({ FBtoken }));
//
//     userService.logFB(FBtoken)
//       .then(
//         user => {
//           dispatch(success(user));
//           history.push('/');
//         },
//         error => {
//           dispatch(failure(error));
//           dispatch(alertActions.error(error));
//         }
//       );
//   };
//   function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
//   function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
//   function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
// }

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function getAll() {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js